/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { MCImage } from './media.image.js';

export let MCText = function() {
	var media_class = 4;
	return Object.assign( {}, MCImage, {
	} );
}(); // namespace MCText

